import {
  api_edit_privacy_settings_path,
  api_email_settings_path,
  api_gift_subscription_settings_path,
  api_update_email_settings_path,
  api_update_privacy_settings_path,
  api_update_user_info_path,
  api_user_account_path,
} from '@routes';
import { getJWT } from '@utils/jwtHelper';

import { SuccessResponse } from '../interfaces';
import request from './request';

export const USER_ACCOUNT_SETTINGS_KEY = 'user_dashboard_settings_key';
export const GIFT_SUBSCRIPTION_SETTINGS_KEY = 'gift_subscription_settings_key';
export const USER_EMAIL_SETTINGS_KEY = 'user_email_settings_key';
export const PRIVACY_SETTINGS_KEY = 'privacy_settings_key';

export interface SettingsResponse {
  canResumeSubscription: boolean;
  canRestartSubscription: boolean;
  canUpdatePayment: boolean;
  canViewPaymentHistory: boolean;
  eligibleToUpgrade: boolean;
  isRevcatSubscriber: boolean;
  trial: {
    accessDaysRemaining?: number;
    dateToCharge?: string;
    expiredFromTrial?: boolean;
    paidThroughDate?: string;
  };
}

export interface UpdateUserParams {
  user: {
    name: string;
    email: string;
    password?: string;
  };
}

export interface UpdateUserResponse {
  emailVerificationRequired?: boolean;
  message?: string;
  error?: string;
}

export interface GiftSubscriptionReponse {
  offer: {
    initialPrice: number;
  };
}

export interface EmailSettings {
  articleNotifications: string;
  commentNotificationEnabled: boolean;
  sendEventEmails: boolean;
  sendForumDigest: boolean;
  sendPromotionEmails: boolean;
  sendProductEmails: boolean;
  surveyEnabled: boolean;
}

export interface EmailSettingsParams {
  user: {
    article_notifications?: string;
    comment_notification_enabled?: boolean;
    send_event_emails?: boolean;
    send_forum_digest?: boolean;
    send_promotion_emails?: boolean;
    send_product_emails?: boolean;
    survey_enabled?: boolean;
  };
}

export interface AffiliateSettingsParams {
  payment_id: string;
  payment_type: string;
}

export interface AffiliateSettings {
  paymentId?: string;
  paymentType: {
    label?: string;
    value?: string;
  };
}

export interface PrivacySettingsParams {
  user: {
    ccpa_do_not_sell_personal_info: boolean;
  };
}

export interface PrivacySettingResponse {
  ccpaDoNotSellPersonalInfo: boolean;
}

export async function getUserSetting(): Promise<SettingsResponse> {
  const resp = await request('get', api_user_account_path());
  return resp;
}

export async function updateUserInfo(params: UpdateUserParams): Promise<UpdateUserResponse> {
  const resp = await request('put', api_update_user_info_path(params));
  return resp;
}

export async function giftSubscriptionSettings(): Promise<GiftSubscriptionReponse> {
  const resp = await request('get', api_gift_subscription_settings_path());
  return resp;
}

export async function getEmailSettings(): Promise<EmailSettings> {
  const resp = await request('get', api_email_settings_path(getJWT()));
  return resp;
}

export async function updateEmailSettings(params: EmailSettingsParams): Promise<SuccessResponse> {
  const resp = await request('put', api_update_email_settings_path({ ...params, ...getJWT() }));
  return resp;
}

export async function getPrivacySettings(): Promise<PrivacySettingResponse> {
  const resp = await request('get', api_edit_privacy_settings_path());
  return resp;
}

export async function updatePrivacySettings(
  params: PrivacySettingsParams
): Promise<SuccessResponse> {
  const resp = await request('put', api_update_privacy_settings_path(params));
  return resp;
}
